import React from 'react';
import LeaveDetailView from '../../components/shared/LeaveDetailView';

const EmployeeLeaveDetail = () => {
  return (
    <div style={{ padding: '24px' }}>
      <LeaveDetailView />
    </div>
  );
};

export default EmployeeLeaveDetail;